import React from 'react';

import { Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import routes from 'app/routes';
import Form from '../Form/Index';
import { useContext } from '../../Context';

export default function Index() {
  const navigate = useNavigate();
  const { dispatch, actions, state } = useContext();
  const { categoryId } = useParams();

  const onSave = (values, callback) => {
    actions.update(dispatch, categoryId, values, () => {
      callback();
    });
  };
  const row = state.categories === null ? null : state.categories.find((item) => item.id === categoryId);

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={() => navigate(routes.admin.resource_categories.index)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Category
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {row === null ? 'Please wait ...' : <Form category={row} onSave={onSave} />}
      </Modal.Body>
    </Modal>
  );
}
